import EligibilityValidationMessage from './EligibilityValidationMessage';

export default class BindingAuthorityEligibilityResult {
	public id: string | null = null;
	public policies_id: number | null = null;
	public bindingAuthorityAgreement_Id: number | null = null;
	public isEligible: boolean | null = null;
	public validationMessages: string | null = null;
	public validationMessagesList: EligibilityValidationMessage[] = [];

	public constructor() {

	}
};